import { useTranslation } from "react-i18next";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";

const Master = () => {
  const { t } = useTranslation();
  const m = (k: string) => t(`master.${k}`);
  const features: string[] = t("master.features", {
    returnObjects: true,
  }) as string[];

  return (
    <section className="bg-gradient-to-b from-[#e0f7ff] via-[#f0fbff] to-[#f9fdff] py-20 font-sans">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 md:px-6">
        <div className="flex flex-col-reverse lg:flex-row bg-white rounded-md shadow-2xl overflow-hidden">
          {/* Text Section */}
          <div className="w-full lg:w-1/2 p-8 md:p-12 lg:p-14 flex flex-col justify-center text-[#003049]">
            <h2 className="text-3xl md:text-4xl font-extrabold leading-tight mb-4 text-[#009fe3]">
              {m("title")}
            </h2>
            <div className="w-14 h-1 bg-[#009fe3] rounded-full mb-6"></div>
            <p className="text-base md:text-lg text-gray-700 mb-6 leading-relaxed">
              {m("bodyPart1")}
              <span className="font-semibold text-[#009fe3]">
                {m("bodyHighlight1")}
              </span>
              {m("bodyPart2")}
              <span className="font-bold text-[#009fe3]">
                {m("bodyHighlight2")}
              </span>
              {m("bodyPart3")}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-[#009fe3]">
              {m("whyTitle")}
            </h3>
            <ul className="space-y-3 text-gray-800 text-base">
              {features.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <svg
                    className="w-5 h-5 mt-1 text-[#009fe3] flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2.5}
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Image Section */}
          <div className="w-full lg:w-1/2 h-80 lg:h-auto relative">
            <ImageWithBasePath
              src="assets/img/feature/start-your-journey.png"
              alt="Start Journey"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Master;
